import AppRouter from "./AppRouter";
import { BrowserRouter } from "react-router-dom";
import Wayfinding from "./wayfinding/Wayfinding";
import "@cbw/widgets";

function App() {
  return (
    <div className="App">
      <cbw-header
        app-id="160"
        use-icon-logo="false"
        use-global-navigation="false"
        use-login-widget="false"
        use-search-widget="false"
        use-cb-logo-link="false"
        skip-target-id="iam"
      ></cbw-header>
      <Wayfinding
        appId="160"
        DURL="https://store.collegeboard.org"
        disableLoginLink={true}
        endpoints={{
          studentHelp:
            "https://support.collegeboard.org/help-center/account-help",
          professionalHelp:
            "https://support.collegeboard.org/help-center/professional-account-help",
        }}
      />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
